import                 './filters';
import                 './registerServiceWorker'
import                 './scss/styles.scss'
import App        from './App.vue';
import i18next    from 'i18next';
import Icons      from 'uikit/dist/js/uikit-icons';
import resources  from '../locales';
import router     from './router'
import UIkit      from 'uikit';
import Vue        from 'vue';
import VueI18Next from '@panter/vue-i18next';

UIkit.use(Icons);

Vue.config.productionTip = false
Vue.config.devtools      = true

i18next.init({
    fallbackLng: 'nl',
    lng:         'nl',
    defaultNS:   'main',
    resources,
}).then(() => {
    Vue.use(VueI18Next);

    const app = new Vue({
        router,
        render: h => h(App),
        i18n:   new VueI18Next(i18next),
    }).$mount('#app');

    const initDevTools = (retries = 10) => {
        if (window.__VUE_DEVTOOLS_GLOBAL_HOOK__) {
            window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app.constructor;
        } else if (retries > 0) {
            setTimeout(() => initDevTools(retries - 1), 100);
        }
    };
    initDevTools();
});
